import React from 'react'
import PropTypes from 'prop-types'
import { Icon } from 'antd'
import { formatReminderNumber } from '../../services/utils'
import css from './phone-numbers.css'

const ExistingPhoneNumbersList = ({
  countryCode,
  toggleModal,
  purchasedNumbers,
  setEditingPhoneNumberId,
}) => {
  const formattedNumber = (number, preferred) => {
    const plus = countryCode === 'NZ' ? '' : '+'
    const asterisk = preferred ? '*' : ''
    return `${plus}${formatReminderNumber(number)}${asterisk}`
  }

  const handleOnClick = (phoneNumberId) => {
    toggleModal(true, 'edit')
    setEditingPhoneNumberId(phoneNumberId)
  }

  return (
    <div className={css.phoneNumbersList}>
      {purchasedNumbers.map(({
          id,
          phone_number: number,
          is_preferred: preferred,
          twilio_sid: twilioSid,
        }) => (
          <div key={id} className={css.phoneNumberListItem}>
            <span className={css.phoneNumberText}>
              <div dangerouslySetInnerHTML={{ __html: formattedNumber(number, preferred) }} />
            </span>
            {twilioSid ? (
              <div onClick={() => handleOnClick(id)} className={css.editButton}>
                <Icon type="edit" />
              </div>
            ) : (
              <span className={css.noEdit}>
                {`Contact support to edit this number (#${id}).`}
              </span>
            )}
          </div>
        ))}
    </div>
  )
}

ExistingPhoneNumbersList.propTypes = {
  countryCode: PropTypes.string.isRequired,
  toggleModal: PropTypes.func.isRequired,
  purchasedNumbers: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    phone_number: PropTypes.string.isRequired,
    is_preferred: PropTypes.bool.isRequired,
  }).isRequired).isRequired,
  setEditingPhoneNumberId: PropTypes.func.isRequired,
}

export default ExistingPhoneNumbersList



// WEBPACK FOOTER //
// ./src/AddPractice/Associations/ExistingPhoneNumbersList.js